'use strict'

module.exports = function () {
	$('.js-tiered-price-link').bind('click', function(e) {
		e.preventDefault();
		$('#tieredPrices_'+$(this).attr('rel')).modal('show');
	});
};